module.exports = __webpack_public_path__ + "img/no-heatmap.869d2cb1.svg";